import React from 'react';
import './index.css';

const IconTrashCan = (props) => {
  return (
    <svg
      {...props}
      className={`icon-trash-can ${props.className ? props.className : ''}`}
      width="14"
      height="18"
      viewBox="0 0 14 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.499 0H9.499L10.5 1.001H12.999C13.552 1.001 14 1.449 14 2V3.001H0V2C0 1.449 0.448 1.001 0.999 1.001H3.5L4.499 0Z" />
      <path d="M0.999023 4.00098H12.999V16.001C12.999 17.105 12.105 18.001 10.999 18.001H3.00002C1.89502 18.001 0.999023 17.105 0.999023 16.001V4.00098Z" />
    </svg>
  );
}

export default IconTrashCan;